import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoadingScreen = () => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    height: '100vh', background: '#fff', fontFamily: "'Source Sans 3', sans-serif",
  }}>
    <img src="/icona.svg" alt="NeoFlux" style={{ height: 48, marginBottom: 24, opacity: 0.8 }} />
    <div style={{
      width: 32, height: 32,
      border: '3px solid #e5e7eb', borderTopColor: '#000e9c',
      borderRadius: '50%',
      animation: 'nf-spin 0.8s linear infinite',
    }} />
    <style>{`@keyframes nf-spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const ProtectedRoute = () => {
  const { autenticato, caricamento } = useAuth();

  useEffect(() => {
    if (!caricamento && !autenticato) {
      window.location.href = '/auth/login';
    }
  }, [autenticato, caricamento]);

  if (caricamento || !autenticato) {
    return <LoadingScreen />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
